import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@/store/index";
import { selectUiPinnedSize } from "../ui/selectors";
import { ParticipantSid } from "./types";

export const selectRoom = (state: RootState) => state.room;

export const selectRoomParticipants = createSelector(
  selectRoom,
  (room) => room.participants,
);

export const selectRoomTotalParticipants = createSelector(
  selectRoomParticipants,
  (participants) => participants.length,
);

export const selectRoomParticipantsById = createSelector(
  selectRoom,
  (room) => room.participantsById,
);

export const selectRoomParticipantInfo = (
  sid: ParticipantSid,
) => createSelector(
  selectRoomParticipantsById,
  (participantsById) => participantsById[sid],
);

export const selectRoomParticipantName = (
  sid: ParticipantSid,
) => createSelector(
  selectRoomParticipantInfo(sid),
  (participantInfo) => participantInfo?.user?.name || '',
);

export const selectRoomPinned = createSelector(
  selectRoom,
  (room) => room.pinned,
);

export const selectRoomPinnedSize = (
  sid: ParticipantSid,
) => createSelector(
  [
    selectRoomPinned,
    selectUiPinnedSize,
  ],
  (pinned, sizes) => {
    if (pinned === sid) {
      return sizes;
    }

    return null;
  },
);
